import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInstallBattery = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 555,
	height: 375,
	viewBox: "0 0 555 375",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.58 119.028C8.45507 115.626 7.17696 113.218 9.4488 105.989C10.5863 102.022 13.9925 98.7595 20.0986 94.9328C26.2048 91.1061 107.294 42.3505 107.294 42.3505C120.785 34.2729 136.55 29.3109 149.188 29.4544C161.825 29.5979 169.497 30.0221 169.497 30.0221C179.862 30.8735 181.425 31.2976 183.84 32.0056C186.256 32.7135 193.071 34.4164 196.337 38.5238C199.602 42.6311 221.19 68.1458 221.19 68.1458C232.268 79.9097 236.76 83.0636 243.486 85.5797C244.624 86.0038 247.675 87.8119 247.535 90.9658C247.535 90.9658 511.569 194.182 516.682 196.201C521.794 198.219 526.162 200.77 531.061 205.024C534.895 207.151 545.439 213.634 543.736 223.201C542.033 232.768 540.007 243.291 539.157 246.799C538.307 250.307 537.56 252.007 533.939 255.728C530.319 259.45 464.922 325.671 457.678 333.114C444.165 346.996 425.361 349.885 403.144 340.13C387.165 333.111 23.5431 171.965 17.3667 168.776C11.1902 165.587 5.64962 160.484 4.69104 141.246C4.79648 135.611 5.8637 130.722 6.18323 128.385C6.50276 126.047 6.96288 123.177 11.58 119.032V119.028Z",
			fill: "#CED3DA",
			stroke: "#6F7780",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M116.503 189.604C116.987 174.797 126.179 163.047 136.661 156.287L242.091 87.5616C279.721 102.691 506.136 192.405 512.587 194.594C520.651 197.33 526.295 201.032 531.617 205.217C538.713 208.918 543.067 215.196 544.035 218.736C545.003 222.277 543.229 225.496 541.777 227.267C540.326 229.037 540.003 231.774 539.358 232.9C538.713 234.027 465.657 306.455 463.883 307.904C462.109 309.353 460.98 310.801 459.367 311.445C457.754 312.089 456.303 311.445 453.884 314.02C451.465 316.595 448.401 317.239 446.788 317.239C445.175 317.239 445.336 319.975 445.498 321.424C445.659 322.873 445.659 323.677 444.369 324.482C443.079 325.287 432.273 326.575 427.597 326.253C422.92 325.931 412.437 323.355 409.373 322.39C406.309 321.424 406.309 318.688 406.147 317.239C405.986 315.791 405.825 315.63 404.051 315.147L129.243 195.559C125.964 194.165 118.825 191.021 116.503 189.604Z",
			fill: "#A1A8B0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.273 157.012C122.917 164.665 119.51 175.721 116.385 185.358L116.245 189.893C116.245 189.893 73.4985 171.113 57.9504 165.587C42.399 160.06 15.1337 151.342 12.5775 150.918C10.0213 150.493 8.10415 148.366 5.9729 145.391",
			stroke: "#6F7780",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.36 191.736L129.307 195.563L135.592 195.135",
			stroke: "#6F7780",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M216.787 233.546C216.787 233.546 403.106 315.042 404.525 315.466C405.943 315.89 406.228 315.89 406.372 317.309C406.515 318.728 406.087 321.136 409.922 322.412C413.756 323.687 423.412 325.814 428.524 326.098C433.637 326.382 441.021 325.39 442.868 324.823C444.715 324.255 445.565 323.831 445.565 321.847C445.565 319.864 445.28 318.161 446.843 317.737C448.405 317.313 448.83 317.596 450.677 316.745C452.524 315.894 454.652 313.342 456.643 312.494C458.63 311.643 459.483 311.926 461.471 310.227C463.458 308.527 465.874 305.976 465.874 305.976C465.874 305.976 537.732 234.404 538.726 233.409C539.72 232.417 540.145 229.582 541.423 227.739",
			stroke: "#6F7780",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M537.733 241.623C537.733 241.623 456.928 323.4 455.509 324.676C454.091 325.952 452.528 325.811 452.528 323.541C452.528 321.27 452.953 318.863 452.953 318.863C454.94 317.587 458.634 315.744 460.762 314.044C462.89 312.344 534.608 239.777 536.596 237.934C538.583 236.091 539.292 235.807 540.571 232.548",
			stroke: "#6F7780",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M303.922 280.959L303.973 277.684C303.976 277.378 304.127 277.094 304.376 276.919L305.731 275.959C306.009 275.761 306.37 275.726 306.68 275.866L322.371 282.955C322.554 283.038 322.704 283.175 322.806 283.347L324.589 286.418C324.669 286.556 324.714 286.709 324.717 286.868L324.787 288.995C324.816 289.933 323.854 290.583 322.995 290.204L304.682 282.148C304.213 281.941 303.912 281.476 303.919 280.962L303.922 280.959Z",
			stroke: "#6F7780",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M308.526 276.632C308.526 277.41 308.526 278.261 309.733 278.759C310.941 279.256 323.224 284.145 323.224 284.145",
			stroke: "#6F7780",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M83.777 182.618C83.6964 182.563 83.6013 182.663 83.6598 182.741L87.6869 188.099C87.9356 188.43 88.4623 188.254 88.4623 187.84V185.942L90.5331 187.525C90.611 187.585 90.712 187.489 90.6564 187.408L87.0263 182.135C86.7806 181.778 86.2209 181.967 86.241 182.4L86.331 184.347L83.777 182.618Z",
			fill: "#6F7780"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M102.406 190.291C103.633 193.078 102.87 195.279 100.729 195.225C98.588 195.17 95.9231 192.919 94.7025 190.189C93.4755 187.447 94.1721 185.215 96.2842 185.215C98.3962 185.215 101.176 187.495 102.41 190.291H102.406Z",
			fill: "#6F7780"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.35303 126.682C7.778 129.338 9.27019 132.741 12.4655 134.549C14.4881 135.081 31.5316 139.119 34.2987 139.865C37.069 140.608 39.6253 141.035 39.5166 136.995C39.408 132.954 38.7721 130.403 36.9604 128.598C35.1487 126.793 29.2917 125.623 27.3746 125.09C25.4574 124.558 15.9771 122.434 13.5295 120.521",
			stroke: "#6F7780",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1874 123.917C12.0405 125.617 12.4655 127.957 17.1529 129.338C21.8404 130.719 31.8512 133.27 31.8512 133.27",
			stroke: "#6F7780",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7202 105.845C13.4233 107.972 15.1296 108.61 20.0279 109.034C24.9263 109.458 40.6917 110.734 46.8682 111.161C53.0446 111.585 68.3819 111.799 77.1178 110.099C85.8537 108.399 95.6504 101.594 99.4847 98.6189C103.319 95.6436 183.201 45.0449 186.61 43.1315C190.019 41.2181 192.362 38.8806 191.083 36.1158",
			stroke: "#6F7780",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M161.684 134.619C157.14 133.344 153.731 131.5 152.028 128.241C150.325 124.982 149.756 121.863 153.306 119.453C156.856 117.042 181.425 100.743 184.406 98.7596C187.387 96.7761 190.371 94.649 194.346 97.484C198.321 100.319 202.44 105.137 202.44 105.137",
			stroke: "#6F7780",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.471 104.429C196.193 104.289 192.074 102.87 188.808 104.997C185.543 107.124 158.843 125.122 157.424 126.257C156.006 127.393 155.862 128.809 156.006 129.66",
			stroke: "#6F7780",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.135 195.585L132.853 197.836C132.594 198.091 132.502 198.477 132.62 198.822C134.611 204.75 135.413 206.615 135.413 206.615C136.55 209.734 139.247 212.709 142.228 213.985C145.209 215.26 174.75 228.868 175.884 229.292C177.021 229.716 178.015 229.716 178.581 228.868C178.951 228.316 179.258 227.822 179.431 227.544C179.527 227.391 179.574 227.216 179.571 227.034L179.437 214.049C179.434 213.666 179.201 213.322 178.849 213.175L136.176 195.381C135.818 195.231 135.406 195.311 135.131 195.582L135.135 195.585Z",
			fill: "#CED3DA",
			stroke: "#6F7780",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M136.975 199.53L175.331 216.013C175.67 216.16 175.897 216.488 175.91 216.855L176.312 227.589",
			stroke: "#6F7780",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M184.297 215.739C183.955 215.589 183.556 215.649 183.275 215.898C182.958 216.182 182.271 217.049 182.064 217.225C181.69 217.544 181.639 217.544 181.639 218.66C181.639 219.776 181.923 228.086 181.923 228.829C181.923 229.572 182.029 230.319 182.882 230.688C183.735 231.058 206.313 241.85 206.313 241.85C209.029 243.02 211.69 241.636 212.758 240.096C213.825 238.556 214.729 236.693 215.1 234.78C215.362 233.431 215.678 231.416 215.841 230.35C215.905 229.923 215.675 229.505 215.279 229.33L184.294 215.736L184.297 215.739Z",
			fill: "#CED3DA",
			stroke: "#6F7780",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M183.128 218.947L213.08 231.285C213.419 231.432 213.646 231.76 213.658 232.127L212.949 236.378",
			stroke: "#6F7780",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.7314 113.712C79.5658 114.35 83.0806 115.307 85.9563 120.09C88.832 124.874 103.211 147.515 105.767 150.704C108.323 153.893 114.075 162.822 120.146 165.054",
			stroke: "#6F7780",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.242 194.497L365.757 262.527L368.207 259.552L374.064 258.062L378.752 259.443L386.315 252.641L394.837 251.579C393.559 250.728 393.239 248.604 394.303 247.539C395.367 246.474 396.965 244.883 398.138 243.926C399.31 242.969 400.48 242.864 402.186 243.502C403.892 244.14 409.001 246.267 409.001 246.267L424.233 234.043L416.351 230.855L419.332 220.969",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M445.319 218.947L463.743 226.706L434.88 253.174",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M432.644 221.074L452.029 229.151L428.704 250.412",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M453.732 228.833L460.656 227.344",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M434.879 253.174L416.561 245.415L411.129 245.734",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M410.276 247.329L425.399 254.45L406.442 271.246L378.748 259.447",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M369.802 260.298L409.529 277.199L434.027 254.239C431.471 253.069 415.6 246.161 415.6 246.161L410.593 246.375",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M398.559 251.155L405.697 250.412L409.103 247.434L404.205 245.521L398.559 251.155Z",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M386.631 253.601L406.337 251.369L409.852 248.071",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M413.577 244.353L433.707 227.771L421.993 222.56",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M498.111 249.421C493.567 243.751 485.055 237.924 479.224 234.822C477.092 233.686 475.958 232.978 477.377 231.419C478.795 229.86 495.411 214.412 495.411 214.412C499.938 209.441 496.689 205.844 490.583 203.073C485.895 200.946 474.961 196.554 474.961 196.554",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M499.105 250.518C499.958 251.369 501.981 252.645 502.514 252.645C503.048 252.645 506.774 248.499 506.774 248.499C506.774 248.499 503.898 244.248 502.725 243.183C501.553 242.121 500.064 241.056 501.342 239.57C502.62 238.081 507.093 234.044 507.946 233.297C508.799 232.551 510.078 232.341 511.036 233.297C511.995 234.254 513.167 235.389 514.017 236.308C514.698 237.044 516.359 239.143 516.359 239.143L522.645 232.979C522.645 232.979 521.686 231.17 520.513 230.003C519.341 228.833 518.702 227.238 520.194 225.963C521.686 224.687 526.584 219.585 526.584 219.585L526.051 207.786C526.051 207.786 524.453 203.216 521.577 201.622C518.702 200.027 516.784 199.603 515.506 199.495C514.228 199.389 512.631 199.39 511.138 198.643C509.646 197.9 504.642 195.878 504.003 195.349C503.364 194.82 501.661 192.903 503.364 191.947",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M490.691 187.59C490.905 188.123 492.289 188.333 493.353 188.761C494.417 189.188 497.721 190.674 498.36 190.674C498.999 190.674 499.319 190.141 499.319 190.141",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M516.999 205.873C517.999 205.873 518.81 205.302 518.81 204.597C518.81 203.893 517.999 203.322 516.999 203.322C515.998 203.322 515.187 203.893 515.187 204.597C515.187 205.302 515.998 205.873 516.999 205.873Z",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M491.756 195.349C492.815 195.349 493.673 194.778 493.673 194.074C493.673 193.369 492.815 192.798 491.756 192.798C490.697 192.798 489.839 193.369 489.839 194.074C489.839 194.778 490.697 195.349 491.756 195.349Z",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M508.797 247.433C508.797 247.433 505.068 242.969 504.429 242.436C503.79 241.904 503.895 240.842 504.643 240.099C505.391 239.356 508.477 237.015 509.116 236.272C509.755 235.529 510.394 235.848 511.139 236.696C511.883 237.545 515.187 241.48 515.187 241.48",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M507.628 245.839L510.929 242.969",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M455.17 305.102C455.17 305.102 452.649 301.435 452.01 300.902C451.371 300.37 451.476 299.308 452.224 298.565C452.971 297.822 458.419 293.09 459.058 292.347C459.697 291.604 460.336 291.922 461.081 292.771C461.825 293.619 463.922 296.757 463.922 296.757",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M454.317 302.87L459.662 298.246",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M526.159 234.254C525.415 232.979 523.389 230.214 522.644 229.576C524.028 228.3 530.418 222.136 530.418 222.136C531.482 223.093 533.189 226.068 533.828 227.238",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M525.412 232.873C525.412 232.873 529.352 228.941 532.227 227.984",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M535.425 209.38C537.557 212.464 542.669 220.436 535.64 227.876C528.61 235.316 455.972 307.28 455.972 307.28C452.671 310.575 448.303 314.082 443.085 315.147",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M421.246 316.847C424.227 317.166 427.85 317.485 432.215 317.271C436.58 317.058 439.35 316.315 440.628 315.996C441.906 315.677 442.97 315.572 443.718 316.209C444.466 316.847 445.102 317.59 445.102 317.59",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M434.986 317.699L434.446 322.466C434.391 322.957 433.97 323.324 433.474 323.314L430.097 323.244C429.608 323.234 429.205 322.858 429.161 322.37L428.809 318.336",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M421.14 319.185C421.565 320.355 421.674 321.312 423.802 321.522C425.933 321.736 428.915 321.522 428.915 321.522",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M434.56 321.312C436.052 321.206 437.969 320.779 439.139 320.569C440.312 320.355 441.59 319.293 441.801 317.912",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M406.867 315.572C407.72 315.358 408.465 314.721 408.465 314.721C410.276 315.572 416.239 317.272 417.306 317.485",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M408.464 316.847C408.678 317.804 408.145 319.612 410.487 320.46C412.829 321.312 416.452 322.055 417.302 322.268C418.152 322.482 419.859 321.949 420.178 320.888C420.498 319.826 420.712 317.38 420.712 317.38",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M473.008 283.417C471.784 281.664 469.493 278.634 468.64 277.996C467.787 277.359 467.627 276.561 468.426 275.71C469.225 274.858 472.74 271.405 473.433 270.872C474.127 270.34 474.446 270.18 475.191 271.032C475.935 271.883 478.651 275.656 479.29 276.931",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M474.236 271.405C474.236 271.405 474.45 275.975 474.45 276.721C474.45 277.467 471.52 279.805 471.36 279.964",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M491.597 268.854C490.903 267.473 489.465 264.813 488.775 264.284C488.085 263.755 488.031 262.954 488.67 262.425C489.309 261.896 495.166 256.471 495.594 256.152C496.022 255.833 496.338 255.62 496.818 256.152C497.297 256.685 499.534 259.82 499.639 260.298C499.744 260.776 499.904 261.2 499.16 261.998",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M496.763 261.306C496.444 262.741 495.699 263.643 492.184 266.568",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M498.839 260.563C498.414 260.403 495.75 259.392 495.75 259.392",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M506.934 192.852C506.109 192.559 505.656 192.559 505.31 193.012C504.965 193.464 505.176 194.182 506.349 195.03C507.522 195.882 508.72 196.385 510.742 196.57C512.765 196.755 513.618 196.784 514.363 196.65C515.107 196.516 515.935 196.436 515.746 196.277",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M464.311 225.893L488.17 203.427L474.821 198.114",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M486.378 203.481L479.243 204.173C479.243 204.173 476.367 206.51 476.102 206.778C475.837 207.046 476.048 207.362 476.527 207.47C477.006 207.579 477.591 207.894 477.591 207.894C478.23 208.054 478.869 208.478 477.856 209.384C476.843 210.289 470.881 215.867 470.881 215.867C470.881 215.867 467.312 214.696 466.941 214.645C466.57 214.594 465.717 214.327 465.238 214.591",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M465.768 215.972L463.317 217.885L466.618 219.32L469.123 217.298L465.768 215.972Z",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M464.222 220.437L461.72 219.32L459.538 221.498C459.538 221.498 457.835 221.285 457.142 221.977",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M455.809 221.817L468.59 210.442",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M467.897 214.005L469.922 212.037",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M469.603 214.588L470.667 213.472",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M474.981 211.772L474.514 211.089C474.326 210.815 474.383 210.439 474.642 210.232L474.971 209.97C475.144 209.833 475.37 209.795 475.578 209.865L476.789 210.283",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M405.802 244.883L406.678 244.127C406.86 243.971 407.112 243.929 407.336 244.018L410.276 245.202",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M411.875 243.821L408.935 242.638C408.715 242.548 408.459 242.59 408.277 242.746L407.401 243.502C407.277 243.661 407.309 243.846 407.337 244.018",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M413.471 242.44L410.532 241.257C410.311 241.168 410.056 241.209 409.874 241.365L408.998 242.121C408.873 242.281 408.905 242.466 408.934 242.638",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M415.335 241.164L412.13 239.876C411.909 239.787 411.654 239.828 411.472 239.984L410.596 240.74C410.472 240.9 410.504 241.085 410.532 241.257",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M416.932 239.78L413.727 238.492C413.507 238.403 413.251 238.444 413.069 238.6L412.194 239.356C412.069 239.516 412.101 239.701 412.13 239.873",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M418.728 238.47L415.326 237.108C415.105 237.019 414.849 237.061 414.667 237.217L413.792 237.973C413.667 238.132 413.699 238.317 413.728 238.489",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M420.326 237.089L416.923 235.727C416.702 235.638 416.447 235.679 416.265 235.836L415.389 236.591C415.265 236.751 415.297 236.936 415.325 237.108",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M422.029 235.743L418.521 234.347C418.301 234.257 418.045 234.299 417.863 234.455L416.987 235.211C416.863 235.37 416.895 235.555 416.923 235.727",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M470.916 267.773C471.769 267.065 472.619 266.638 473.612 267.276C474.606 267.913 474.75 268.337 475.245 268.621C475.74 268.905 476.098 269.329 476.948 268.551C477.798 267.773 480.923 264.795 481.706 263.873C482.489 262.951 483.268 262.03 482.061 260.614C480.853 259.198 474.322 253.244 471.337 251.261C468.353 249.277 466.084 248.212 465.231 248.002C464.378 247.791 463.953 248.072 463.173 248.853C462.394 249.634 424.901 284.853 424.476 285.421C424.051 285.988 424.051 286.696 424.974 287.194C425.897 287.691 435.768 294.423 436.618 294.987C437.468 295.552 438.605 295.555 439.388 294.633C440.171 293.712 443.507 287.972 444.855 286.556C446.203 285.14 454.3 277.84 455.01 277.273C455.719 276.705 456.642 276.495 457.566 277.133C458.489 277.77 459.199 278.692 459.908 278.622C460.617 278.552 470.912 267.779 470.912 267.779L470.916 267.773Z",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M451.745 290.095C450.965 290.519 450.537 290.519 450.042 289.882C449.547 289.244 448.339 288.606 447.556 287.968C446.773 287.33 446.633 287.117 447.131 286.479C447.63 285.841 454.161 279.747 455.084 278.896C456.008 278.044 456.503 278.258 457.001 278.755C457.57 279.323 459.343 281.023 459.698 281.661C460.053 282.298 459.628 282.439 459.2 282.936",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M450.396 279.75C451.25 278.899 451.675 278.191 450.537 277.059C449.4 275.924 448.265 275.075 447.271 274.721C446.278 274.367 445.639 274.084 444.715 275.005C443.792 275.927 441.804 277.697 441.165 278.408C440.526 279.119 440.312 280.037 441.236 280.745C442.159 281.453 443.223 282.091 443.722 282.518C444.22 282.946 444.575 283.44 445.07 282.872C445.565 282.305 446.278 281.313 446.703 281.597C447.128 281.881 447.696 282.659 448.195 282.094",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M454.462 271.717C454.596 270.953 453.578 270.138 452.189 269.896C450.8 269.654 449.566 270.076 449.432 270.84C449.299 271.603 450.316 272.418 451.705 272.66C453.094 272.903 454.328 272.48 454.462 271.717Z",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M466.11 255.662C466.202 255.147 465.578 254.605 464.716 254.453C463.854 254.3 463.081 254.593 462.99 255.108C462.898 255.623 463.522 256.165 464.384 256.318C465.246 256.47 466.019 256.177 466.11 255.662Z",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M436.998 284.221C437.09 283.706 436.466 283.165 435.604 283.012C434.742 282.859 433.969 283.153 433.878 283.668C433.786 284.183 434.41 284.724 435.272 284.877C436.134 285.03 436.907 284.736 436.998 284.221Z",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M414.964 291.725C413.252 294.761 408.503 297.465 405.714 296.477C403.02 295.523 402.253 290.096 403.602 287.828C405.896 283.973 409.836 284.576 412.05 285.137C414.268 285.698 416.68 288.686 414.964 291.725Z",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M269.407 229.608C267.838 232.389 263.493 234.863 260.94 233.958C258.473 233.084 257.773 228.115 259.006 226.039C261.106 222.509 264.71 223.061 266.742 223.574C268.771 224.088 270.976 226.827 269.407 229.608Z",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M452.748 274.011C449.713 274.011 446.751 272.183 446.447 269.814C446.124 267.304 448.911 265.608 452.288 266.099C455.292 266.536 457.496 268.564 457.496 270.586",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M392.95 295.482C392.95 295.482 391.532 299.308 391.247 300.086C390.963 300.864 390.678 301.292 389.471 300.864C388.263 300.44 378.393 296.26 377.613 295.762C376.833 295.265 376.904 294.416 377.188 293.351C377.472 292.286 378.607 289.1 378.607 289.1",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M380.738 291.441C380.738 291.441 379.46 292.93 379.319 293.214C379.179 293.498 379.319 294.066 380.243 294.349C381.166 294.633 390.682 298.316 390.682 298.316",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M313.936 261.015C313.936 261.015 312.584 264.657 312.316 265.397C312.047 266.137 311.776 266.542 310.626 266.14C309.475 265.738 300.084 261.758 299.343 261.287C298.602 260.815 298.669 260.005 298.937 258.994C299.209 257.983 300.289 254.947 300.289 254.947",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M302.315 257.173C302.315 257.173 301.097 258.589 300.963 258.86C300.829 259.131 300.963 259.67 301.842 259.938C302.721 260.209 311.773 263.713 311.773 263.713",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M239.189 229.324C239.189 229.324 237.927 232.73 237.671 233.422C237.415 234.114 237.166 234.493 236.093 234.117C235.019 233.74 226.235 230.019 225.542 229.576C224.848 229.132 224.909 228.377 225.161 227.433C225.414 226.486 226.424 223.651 226.424 223.651",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.321 225.73C228.321 225.73 227.184 227.053 227.059 227.305C226.935 227.557 227.059 228.061 227.88 228.313C228.702 228.565 237.169 231.843 237.169 231.843",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M168.117 198.917C168.117 198.917 166.925 202.125 166.689 202.779C166.452 203.433 166.212 203.79 165.2 203.433C164.187 203.076 155.914 199.571 155.259 199.157C154.604 198.742 154.665 198.028 154.901 197.138C155.141 196.248 156.093 193.573 156.093 193.573",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M157.566 195.279C158.339 195.518 167.011 199.389 167.011 199.389",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M354.608 270.04C355.461 270.324 356.17 270.962 355.317 272.024C354.464 273.085 352.406 278.969 352.122 279.747C351.838 280.525 351.767 280.669 350.914 280.315C350.061 279.961 341.188 276.064 340.475 275.78C339.763 275.496 339.977 275.072 340.121 274.151C340.264 273.229 342.038 268.34 342.677 267.205C343.316 266.07 343.885 265.93 345.019 266.213",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M343.53 267.702L343.46 274.364L351.981 278.121",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M278.059 237.612C278.858 237.876 279.526 238.476 278.724 239.474C277.922 240.472 275.992 245.989 275.727 246.719C275.461 247.45 275.394 247.584 274.595 247.252C273.797 246.92 265.47 243.263 264.805 242.998C264.141 242.733 264.339 242.335 264.473 241.47C264.607 240.606 266.272 236.021 266.869 234.955C267.467 233.89 268 233.76 269.068 234.024",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M267.669 235.418L267.602 241.668L275.596 245.189",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M205.209 206.494C205.964 206.746 206.593 207.31 205.839 208.254C205.085 209.198 203.257 214.409 203.008 215.101C202.759 215.793 202.695 215.917 201.937 215.605C201.18 215.292 193.313 211.835 192.684 211.583C192.055 211.331 192.243 210.955 192.371 210.139C192.499 209.322 194.071 204.989 194.636 203.984C195.202 202.98 195.707 202.852 196.713 203.104",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.391 204.421L195.327 210.327L202.881 213.656",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M216.963 230.108L408.145 313.021C408.145 313.021 414.111 315.572 419.329 316.423",
			stroke: "#A1A8B0",
			strokeWidth: .861801,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M244.762 86.5013C245.321 86.4471 246.705 86.6862 247.797 86.7404C248.89 86.7947 508.691 104.997 508.691 104.997C526.585 106.273 542.136 111.161 549.166 122.004C550.019 123.917 551.936 128.595 547.463 133.06C542.989 137.524 481.535 194.182 472.799 202.26C453.036 220.542 434.411 225.427 404.739 221.926C384.929 219.588 123.984 188.761 123.984 188.761L123.131 184.51C123.984 176.643 123.984 164.525 138.254 154.958C152.527 145.391 233.949 90.9658 237.767 88.3796C239.755 87.0338 242.56 86.3259 244.762 86.5013Z",
			fill: "#9EC5FF",
			stroke: "#146EF5",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M193.638 169.2C193.638 169.2 407.401 190.565 412.833 190.884C418.265 191.203 425.295 188.333 430.088 183.869C434.881 179.404 479.295 141.775 479.295 141.775",
			stroke: "#146EF5",
			strokeWidth: 1.7236
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M531.693 173.115L533.471 154.121L547.272 159.133L542.147 163.716C547.705 178.605 544.499 187.893 529.472 197.53C537.929 187.581 541.37 178.37 536.756 168.233L531.693 173.115Z",
			fill: "#9EC5FF",
			stroke: "#146EF5",
			strokeWidth: 1.7236
		})
	]
});
export default SvgInstallBattery;
